import { z } from "zod";

const booleanFromString = z
	.union([z.boolean(), z.enum(["true", "false"]).transform((value) => value === "true")])
	.default(false);

export const visionSearchParamsSchema = z
	.object({
		locationId: z.string().optional(),
		configId: z.string().optional(),
		partnerToken: z.string().optional(),
		partnerCode: z.string().optional(),
		sessionId: z.string().optional(),
		external_logout_url: z.string().optional(),
	})
	.loose();

export const instructionSearchParamsSchema = visionSearchParamsSchema.extend({
	instructionStep: z.coerce.number().int().min(0).catch(0),
});

export const peerSearchParamsSchema = visionSearchParamsSchema
	.extend({
		sessionId: z.string().min(1),
		skipPairing: booleanFromString,
	})
	.loose();

export const deviceRoleSearchParamsSchema = visionSearchParamsSchema
	.extend({
		"device-role": z.enum(["scanner", "evaluated"]).optional(),
	})
	.loose();

export const imageCaptureSearchParamsSchema = visionSearchParamsSchema
	.extend({
		"retry-angle": z.union([z.string(), z.array(z.string())]).optional(),
	})
	.loose();

export type VisionSearchParams = z.infer<typeof visionSearchParamsSchema>;
export type InstructionSearchParams = z.infer<typeof instructionSearchParamsSchema>;
export type PeerSearchParams = z.infer<typeof peerSearchParamsSchema>;
export type DeviceRoleSearchParams = z.infer<typeof deviceRoleSearchParamsSchema>;
export type ImageCaptureSearchParams = z.infer<typeof imageCaptureSearchParamsSchema>;
